module.exports = __webpack_public_path__ + "img/img_Colleges10.645c16f1.png";